import axios from 'axios'
import _ from 'lodash'
import getTimezoneString from './getTimezone'
import { getActiveLanguage } from '../i18n'
import servicesUtils from './servicesUtils'
import backendStringConstants from './backendStringConstants'
import miscUtils from './miscUtils'

const isOfflineMode = miscUtils.getOfflineModeState()
const storedAPIURL = JSON.parse(
  localStorage.getItem(backendStringConstants.API_URL)
)

const TIMEOUT = 20000
const timezoneString = getTimezoneString()
let PROJECT_NAME = _.get(
  window,
  ['_env_', backendStringConstants.PROJECT_NAME],
  ''
)
PROJECT_NAME = _.trim(PROJECT_NAME)

const serviceConnect = axios.create({
  baseURL: isOfflineMode ? miscUtils.constructBackendUrl() : storedAPIURL,
  timeout: TIMEOUT,
  withCredentials: true
})

serviceConnect.interceptors.request.use(async function interceptorFunc(config) {
  const activeLang = await getActiveLanguage()

  _.set(config, ['headers', 'timezone'], timezoneString)
  _.set(config, ['headers', 'lang'], activeLang)

  // get the csrf tokens only for post calls as per security requirements
  if (config.method === 'post' || config.method === 'patch') {
    const csrfToken = await servicesUtils.csrfService()
    _.set(config, ['headers', servicesUtils.X_CSRF], csrfToken)
  }

  const qXRProjectURLs = ['upload_image/', 'studies/']
  if (qXRProjectURLs.indexOf(config.url) !== -1) {
    _.set(config, ['url'], `qxr/${config.url}`)
  } else if (!_.isEmpty(PROJECT_NAME)) {
    _.set(config, ['url'], `/${PROJECT_NAME}${config.url}`)
  }

  return config
})

serviceConnect.interceptors.response.use(
  response => response,
  err => {
    const errorStatus = _.get(err, ['response', 'status'])

    if (errorStatus === 401 || errorStatus === 405) {
      window.location = '/login?redirect=true'
    }

    if ([400, 403, 404, 500, 502, 503, 504].indexOf(errorStatus) !== -1) {
      // log 4xx, 5xx errors, not logging 401
      // SentryIntegration.logError(err)
    }

    /* eslint-disable no-console */
    console.error('Invalid request', err)

    return Promise.reject(err)
  }
)

export default serviceConnect
